export default __webpack_public_path__ + "static/media/BlueSeed-logo-blue.6e729eae.png";